(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["master-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.master-dropdown[open],.master-mobile-nav[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.master-dropdown[open],.master-mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();
})();
